import { render, staticRenderFns } from "./q-position.vue?vue&type=template&id=9f9612fe&scoped=true&"
import script from "./q-position.vue?vue&type=script&lang=js&"
export * from "./q-position.vue?vue&type=script&lang=js&"
import style0 from "./q-position.vue?vue&type=style&index=0&id=9f9612fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f9612fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zhangenlong/vhall/saas-sdk-questionnaire/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9f9612fe')) {
      api.createRecord('9f9612fe', component.options)
    } else {
      api.reload('9f9612fe', component.options)
    }
    module.hot.accept("./q-position.vue?vue&type=template&id=9f9612fe&scoped=true&", function () {
      api.rerender('9f9612fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/questionnaire/q-position.vue"
export default component.exports